module.exports = __webpack_public_path__ + "static/media/about.de2f1e48.jpg";